<template>
  <div class="container container-fluid card">
    <!-- EN TODOS LOS COMPONENTES (SPINERS Y ERRORES) --> 
    <div v-if="loading" class="spinner-container container-fluid">
      <div class="text-center pt-4">
        <h5>NUEVO FORMULARIO</h5>
      </div> 
      <Loading-Style/>
    </div>
    <transition name="slide-fade">
      <div v-if="!loading" class="container my-4">
        <div v-if="errors.length && !mostrarForm">
          <div class="text-center pt-6">
            <h5>NUEVO FORMULARIO</h5>
          </div>
          <p class="alert alert-danger text-center">
            <ul>
              <li v-for="error in errors" :key="error.mensaje">{{ error.mensaje }}</li>
            </ul>
          </p>
        </div>

        <div v-if="mostrarForm">

          <div class="row">
            <div class="col-md-2">
              <div v-if="mostrarLogo" class="text-center m-auto py-5">
                <img :src="logoStorage" alt="" class="img-logo-company">
              </div>
            </div>

            <div class="col-md-8 d-flex align-items-center">
              <div class="text-center m-auto py-5">
                <h2>{{ formName }}</h2>
              </div>
            </div>
            <div class="col-md-12 text-center">
              <hr class="custom-hr"/>
            </div>
          </div>

          <form @submit.prevent="formPublicCompany">
            <div class="row">
              <div v-if="dataCompany">
                <!-- DATOS PERSONALES -->
                <FormPersonal @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <div v-if="developmentMode">
                <!-- PAIS / CIUDAD / PROVINCIA -->
                <FormCitiesCountry @formDataChanged="updateFormData" :data="{ dataCompaniesForms }" />
                </div>
                <div v-if="developmentModeMAP">
                <!-- MAPA -->
                <FormMap @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentMode">
                <!-- INPUTS PERSONALIZADOS -->
                <FormCustomInput @formDataChanged="updateFormData" :data="{ customInput }" />
                <!-- NUMERO DE SINIESTRO -->
                <FormInsurancePolice @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- NUMERO DE POLIZA ?? -->
                <FormNumberSinester @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentModePhoto">
                <!-- FOTOS TITULOS VEHICULO -->
                <FormPhotoVehicleTitleFile @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />   
                </div>
                <div v-if="developmentModePhoto">
                <!-- FOTOS DOCUMENTO LICENCIA -->
                <FormPhotoDocumentAndLicenceFile @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentMode">
                <!-- SINIESTRO -->
                <FormSinester @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- PERSONAS SINIESTRO -->
                <FormSinesterPersons @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- PERSONAS INSPECCION -->
                <FormNumberInspection @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentModePhoto">
                <!-- FOTOS DENUNCIA -->
                <FormPhotoComplaint @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentMode">
                <!-- OBSERVACIONES DENUNCIA -->
                <FormComplaintObservations @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentModePhoto">
                <!-- FOTOS TIPO DE COBERTURA -->
                <FormPhotoInsuranceCertificate @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentMode">
                <!-- NUMERO DE POLIZA -->
                <FormInsuranceCertificateObservations @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- VEHICULO MOTO -->
                <FormVehicleMoto @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- VEHICULO TERCERO -->
                <FormThirdDriver @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- HUBO HERIDOS -->
                <FormWondeds @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                <!-- DAÑOS MATERIALES -->
                <FormMaterialDamage @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentModePhoto">
                <!-- FOTOS RELACIONADAS -->
                <FormPhotoRetioned @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }" />
                </div>
                <div v-if="developmentMode">
                <!-- TIPO / MARCA / MODELO -->
                <FormVehicleCars @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- GNC -->
                <FormGNC @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                </div>
                <div v-if="developmentModePhoto">
                <!-- TARJETA VERDE / CEDULA GNC/ KILOMETRAJE -->
                <FormPhotoGreenCard @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS CHOQUES -->
                <FormPhotoCrash @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS EN GENERAL -->
                <FormPhotoGeneralCars @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS PRESUPUESTOS -->
                <FormPhotoEstimate @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                </div>
                <div v-if="developmentMode">
                <!-- REPARACION -->
                <FormRepairingLocation @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                </div>
                <div v-if="developmentModePhoto">
                <!-- FOTOS PANORAMICAS VEHICULO -->
                <FormPhotoPanoramicCars @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS MOTO -->
                <FormPhotoMotorcycle @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS VIDRIOS -->
                <FormPhotoGlases @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS INTERIOR -->
                <FormPhotoInside @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS RUEDAS -->
                <FormPhotoWheel @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataWheelConditions, dataWheelMaterials, dataFormsField }"/>
                <!-- FOTO EXTINTOR DE FUEGO -->
                <FormPhotoFireExtinguisher @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                <!-- FOTOS PARTES -->
                <FormPhotoPart @formDataChanged="updateFormData" :data="{ dataCompaniesForms, dataFormsField }"/>
                </div>
              </div>
            </div>
            <div class="row px-4 pt-2">
              <button type="submit" class="btn btn-custom">Enviar</button>
            </div>

          </form>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import { ref, onMounted } from "vue"
  import apiForms from "../../apis/Forms"
  import apiAdmin from "../../apis/Admin"
  import apiStorage from "../../apis/Storage"
  import FormPersonal from "../../components/fomularios/forms/FormPersonal"
  import FormCitiesCountry from "../../components/fomularios/forms/FormCities&Country"
  import FormCustomInput from "../../components/fomularios/forms/FormCustomInput"
  import FormInsurancePolice from "../../components/fomularios/forms/FormInsurancePolice"
  import FormNumberSinester from "../../components/fomularios/forms/FormNumberSinester"
  import FormPhotoVehicleTitleFile from "../../components/fomularios/forms/FormPhotoVehicleTitleFile"
  import FormMap from "../../components/fomularios/forms/FormMap"
  import FormPhotoDocumentAndLicenceFile from "../../components/fomularios/forms/FormPhotoDocumentAndLicenceFile"
  import FormSinester from "../../components/fomularios/forms/FormSinester"
  import FormSinesterPersons from "../../components/fomularios/forms/FormSinesterPersons"
  import FormNumberInspection from "../../components/fomularios/forms/FormNumberInspection"
  import FormPhotoComplaint from "../../components/fomularios/forms/FormPhotoComplaint"
  import FormComplaintObservations from "../../components/fomularios/forms/FormComplaintObservations"
  import FormPhotoInsuranceCertificate from "../../components/fomularios/forms/FormPhotoInsuranceCertificate"
  import FormInsuranceCertificateObservations from "../../components/fomularios/forms/FormInsuranceCertificateObservations"
  import FormVehicleMoto from "../../components/fomularios/forms/FormVehicleMoto"
  import FormThirdDriver from "../../components/fomularios/forms/FormThirdDriver"
  import FormWondeds from "../../components/fomularios/forms/FormWondeds"
  import FormMaterialDamage from "../../components/fomularios/forms/FormMaterialDamage"
  import FormPhotoRetioned from "../../components/fomularios/forms/FormPhotoRetioned"
  import FormVehicleCars from "../../components/fomularios/forms/FormVehicleCars"
  import FormGNC from "../../components/fomularios/forms/FormGNC"
  import FormPhotoGreenCard from "../../components/fomularios/forms/FormPhotoGreenCard"
  import FormPhotoCrash from "../../components/fomularios/forms/FormPhotoCrash"
  import FormPhotoGeneralCars from "../../components/fomularios/forms/FormPhotoGeneralCars"
  import FormPhotoEstimate from "../../components/fomularios/forms/FormPhotoEstimate"
  import FormRepairingLocation from "../../components/fomularios/forms/FormRepairingLocation"
  import FormPhotoPanoramicCars from "../../components/fomularios/forms/FormPhotoPanoramicCars"
  import FormPhotoMotorcycle from "../../components/fomularios/forms/FormPhotoMotorcycle"
  import FormPhotoGlases from "../../components/fomularios/forms/FormPhotoGlases"
  import FormPhotoInside from "../../components/fomularios/forms/FormPhotoInside"
  import FormPhotoWheel from "../../components/fomularios/forms/FormPhotoWheel"
  import FormPhotoFireExtinguisher from "../../components/fomularios/forms/FormPhotoFireExtinguisher"
  import FormPhotoPart from "../../components/fomularios/forms/FormPhotoPart"

  import { handleError, handleSweetInfo } from '../../Utils/StatusHandler'
  import { showSpinner, closeSpinner } from '../../Utils/AlertHandler'


  export default {
    name: "FormView",
    components: {
      FormPersonal,
      FormCitiesCountry,
      FormCustomInput,
      FormInsurancePolice,
      FormNumberSinester,
      FormPhotoVehicleTitleFile,
      FormMap,
      FormPhotoDocumentAndLicenceFile,
      FormSinester,
      FormSinesterPersons,
      FormNumberInspection,
      FormPhotoComplaint,
      FormComplaintObservations,
      FormPhotoInsuranceCertificate,
      FormInsuranceCertificateObservations,
      FormVehicleMoto,
      FormThirdDriver,
      FormWondeds,
      FormMaterialDamage,
      FormPhotoRetioned,
      FormVehicleCars,
      FormGNC,
      FormPhotoGreenCard,
      FormPhotoCrash,
      FormPhotoGeneralCars,
      FormPhotoEstimate,
      FormRepairingLocation,
      FormPhotoPanoramicCars,
      FormPhotoMotorcycle,
      FormPhotoGlases,
      FormPhotoInside,
      FormPhotoWheel,
      FormPhotoFireExtinguisher,
      FormPhotoPart,
    },
    setup() {
      const loading = ref(true);
      const mostrarForm = ref(false);
      const errors = ref([]);
      const alert = ref([]);
      const mostrarLogo = ref(false);

      const id = ref('');
      const slugId = ref('');
      const formName = ref(null);
      const logoPathCompany = ref('');
      const logoStorage = ref('');
      const dataCompany = ref([]);
      const dataWheelConditions = ref([]);
      const dataWheelMaterials = ref([]);
      const dataCompaniesForms = ref([]);
      const dataFormsField = ref([]);
      const dataCompanyId = ref(null);
      const dataCompanyFormId = ref(null);
      const dataCompanyFormName = ref(null);
      const filterCompaniesForms = ref([]);
      const datosFormPublic = ref({});
      const customInput = ref([]);
      const customInputUpdate = ref(false);
      const hasImage = ref(false);
      const verificationPhoto = ref(false)

      const handleErrors = (error) => {
        handleError(error, { errors });
      };

      const handleSweetAlert = (info) => {
        handleSweetInfo(info, { alert });
      };

      const handleLogoError = (error) => {
        console.error('Error al obtener la URL del logotipo:', error);
        mostrarForm.value = true;
      };

      const datosFormulario = async () => {
        console.log('datosFormulario')
        errors.value = [];

        try { 
          const params = {
            slug: slugId.value,
            id: id.value,
          };
          const response = await apiForms.getForms(params);
          if (response) {
            console.log(response)
            dataCompany.value = response.data.company;
            dataWheelConditions.value = response.data.wheelConditions;
            dataWheelMaterials.value = response.data.wheelMaterials;
            dataCompaniesForms.value = dataCompany.value.companiesForms[0];
   
            customInput.value = Object.keys(dataCompaniesForms.value)
              .filter(key => key.startsWith('custom_') && dataCompaniesForms.value[key] !== null && dataCompaniesForms.value[key] !== '')
              .map((key) => ({
                key,
                value: dataCompaniesForms.value[key],
              }));
            
            formName.value = dataCompaniesForms.value.form_name;
            dataCompanyFormId.value = dataCompaniesForms.value.id;
            dataCompanyFormName.value = dataCompaniesForms.value.form_name;
            dataCompanyId.value = dataCompaniesForms.value.company_id;

            // IMPLEMENTACION DE FILTRO:
            const dataKeys = Object.keys(dataCompaniesForms.value);
            const dataValues = Object.values(dataCompaniesForms.value);

            filterCompaniesForms.value = dataKeys.reduce((acc, key, index) => {
              if (dataValues[index] === 1) {
                acc[key] = dataValues[index];
              }
              return acc;
            }, {});

            dataCompaniesForms.value = filterCompaniesForms.value;
            console.log('Filter', dataCompaniesForms.value);
            
            updateLogo();
          } else {
            mostrarForm.value = false;
            console.error('No se encontraron datos en la respuesta.');
          }
        } catch (error) {
          handleErrors(error);
          mostrarForm.value = false;
        } finally {
          setTimeout(() => {
            loading.value = false;
            mostrarForm.value = true;
          }, 500);
        }
      };

      const updateLogo = async () => {
        try {
          const pathLogo = dataCompany.value.logoPath;
          if (pathLogo) {

            const url = apiStorage.imagesPath(pathLogo);
            logoStorage.value = url;
            mostrarLogo.value = true;
          }
        } catch (error) {
          console.error(error);
          handleLogoError(error);
        }
      };

      const getFormsFieldAll = async () => {
        const response = await apiAdmin.getFormsField();
        console.log(response)
        dataFormsField.value = response;
      }

      const updateFormData = (formDataFromChild) => {
        let allImagesPresent = true;

        for (const key in formDataFromChild) {
          if (key.startsWith('photo') || key.startsWith('existing_photo') || key.startsWith('motorcycle_photo') || key.startsWith('relationed_files')) {
            console.log('Verificando:', key);
            
            if (formDataFromChild[key] === null) {
              allImagesPresent = false;
              break;
            }
          }
        }

        hasImage.value = allImagesPresent;
        datosFormPublic.value = Object.assign({}, datosFormPublic.value, formDataFromChild);
      };


      const formPublicCompany = async () => {
        try {

          for (const key in dataCompaniesForms.value) {
            console.log(key);
            if (key.startsWith('photo') || key.startsWith('existing_photo') || key.startsWith('motorcycle_photo') || key.startsWith('relationed_files')) {
              console.log('paso para control de guardado', key);
              verificationPhoto.value = true;
            }
          }
          
          if (verificationPhoto.value) {
            if (!hasImage.value) {
              throw new Error('No image');
            }
          }
          
          showSpinner();

          const formData = new FormData();
          formData.append('company_id', dataCompanyId.value)
          formData.append('company_form_id', dataCompanyFormId.value)
          formData.append('company_form_name', dataCompanyFormName.value)

          for (const key in datosFormPublic.value) {
            if (key.startsWith('custom_field') ) {
              customInputUpdate.value = true;
            }
            if (datosFormPublic.value[key] instanceof File) {
              formData.append(key, datosFormPublic.value[key]);
            } else {
              formData.append(key, datosFormPublic.value[key]);
            }
          }

          if (customInputUpdate.value ) {
            for (const key in customInput.value) {
              if (customInput.value[key]) {
                const index = `custom_${key}`;
                formData.append(index, customInput.value[key].value);
              }
            }
          }

          const response = await apiForms.postCreateFormPublic(formData);

          if (response) {
            closeSpinner();
            handleSweetAlert(response);
          }
        } catch (error) {
          console.error(error);
          closeSpinner();
          handleSweetAlert(error);
        }
      };

      onMounted(() => {
        datosFormulario();
        getFormsFieldAll()
      });

      return {
        developmentMode: true,
        developmentModePhoto: true,
        developmentModeMAP: true,
        hasImage,
        updateFormData,
        loading,
        mostrarForm,
        mostrarLogo,
        errors,
        alert,
        id,
        slugId,
        formName,
        logoPathCompany,
        logoStorage,
        dataCompany,
        dataWheelConditions,
        dataWheelMaterials,
        dataCompaniesForms,
        dataFormsField,
        datosFormPublic,
        customInput,
        dataCompanyId,
        dataCompanyFormId,
        dataCompanyFormName,
        filterCompaniesForms,
        customInputUpdate,
        verificationPhoto,
        handleLogoError,
        formPublicCompany,
        updateLogo,
      };
    },
    created() {
      this.slugId = this.$route.params.slug;
      this.id = this.$route.params.id;
    },
  };
</script>